import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

// import _ from 'lodash'
import TableList from '@/components/TableList/index.vue';
import { sourceList } from '@/common/demand';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';

export default {
  components: {
    TableList: TableList
  },

  props: {
    list: Array,
    columnConfig: Array,
    handleSelectionChange: {
      type: Function,
      default: function _default() {}
    },
    handleChangeAudit: {
      type: Function,
      default: function _default() {}
    },
    handleSortChange: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      tableColumnConfig: [{
        label: '选择',
        prop: 'selection',
        type: 'selection',
        flxed: 'left'
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }, {
        label: '需求ID',
        prop: 'demand_id',
        width: 90,
        sortable: 'custom'
      }, {
        label: '需求名称',
        prop: 'demand_name',
        type: 'link',
        params: {
          link: function link(_ref) {
            var row = _ref.row;

            return '/butler/demand-detail/' + row.demand_id;
          }
        }
      }, {
        label: '任务ID',
        prop: 'id',
        width: 90,
        sortable: 'custom'
      }, {
        label: '图标',
        prop: 'app_icon',
        width: 70,
        type: 'image',
        params: {
          preview: true
        }
      }, {
        prop: 'product-cell',
        slot: 'product-cell'
      }, {
        prop: 'basic-cell',
        slot: 'basic-cell'
      }, {
        prop: 'zip-info-cell',
        slot: 'zip-info-cell'
      }, {
        prop: 'time-cell',
        slot: 'time-cell'
      }, {
        prop: 'staff-cell',
        slot: 'staff-cell'
      }, {
        prop: 'status-cell',
        slot: 'status-cell'
      }, {
        prop: 'audit-cell',
        slot: 'audit-cell'
      }, {
        prop: 'tag-cell',
        slot: 'tag-cell'
      }],

      creativeProvider: []
    };
  },


  computed: {
    tableConfig: function tableConfig() {
      var config = {};
      if (this.$route.query && this.$route.query.order) {
        config = {
          'default-sort': {
            prop: this.$route.query.order.replace('-', ''),
            order: this.$route.query.order.indexOf('-') !== -1 ? 'descending' : 'ascending'
          }
        };
      } else {
        config = {};
      }
      return config;
    },
    innerlist: function innerlist() {
      var _this = this;

      return this.list.map(function (item) {
        var app_info = item.app_info || [];
        return _extends({
          app_icon: app_info.length ? app_info[0].app_icon : '',
          demand_name: (item.demand_info || {}).name,
          material_source_text: (sourceList.find(function (e) {
            return e.value === item.material_source;
          }) || {}).label
        }, item, {
          provider_text: useValueExchangeLabel(item.provider_id, _this.creativeProvider)
        });
      });
    },
    filterColumnConfig: function filterColumnConfig() {
      var _this2 = this;

      var tempConfig = [];
      this.columnConfig.map(function (columnProp) {
        _this2.tableColumnConfig.map(function (item) {
          if (columnProp && item.prop === columnProp) {
            tempConfig.push(item);
          }
        });
      });

      return tempConfig;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.$store.dispatch('config/getCreativeProvider');

            case 2:
              _this3.creativeProvider = _context.sent;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
};